import { ConfirmationModalData, RecordModalData, VhcFilter } from './types';
import { SortTypeEnum } from 'api/generated';
import { create } from 'zustand';

type PaginationType = {
  page: number;
  items_per_page?: number;
  total_count?: number;
};

interface VhcState {
  filter: VhcFilter;
  setFilter: (filter: VhcFilter) => void;
  recordModalIsOpen: boolean;
  recordModalData: RecordModalData | null;
  setRecordModalIsOpen: (data: RecordModalData | null, open: boolean) => void;

  confirmationModalIsOpen: boolean;
  confirmationModalData: ConfirmationModalData | null;
  resetConfirmationModalData: () => void;
  openConfirmationModal: (data: ConfirmationModalData) => void;
  pagination?: PaginationType;
  setPagination: (pagination: PaginationType) => void;
}

export const useVhcStore = create<VhcState>((set) => {
  return {
    filter: {
      paginationPage: 1,
      paginationMaxCount: 30,
      sort: 'dateCreate',
      order: SortTypeEnum.DESC
    },
    setFilter: (filter) => set({ filter }),

    recordModalIsOpen: false,
    recordModalData: null,
    setRecordModalIsOpen: (data, open) => set({ recordModalData: data, recordModalIsOpen: open }),

    confirmationModalIsOpen: false,
    confirmationModalData: null,
    openConfirmationModal: (data) =>
      set({
        confirmationModalIsOpen: true,
        confirmationModalData: data
      }),
    resetConfirmationModalData: () => set({ confirmationModalIsOpen: false, confirmationModalData: null }),
    setPagination: (pagination) => set({ pagination: pagination })
  };
});
